import React from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

interface EpicStatusBannerProps {
  isEpicDone: boolean;
  totalCount: number;
  openCount: number;
  onMarkDone: () => void;
  onReopen: () => void;
  isSaving?: boolean;
}

/**
 * Points out when the Epic's status and its children disagree. The user
 * decides: children never change the Epic's status on their own.
 */
const EpicStatusBanner: React.FC<EpicStatusBannerProps> = ({
  isEpicDone,
  totalCount,
  openCount,
  onMarkDone,
  onReopen,
  isSaving = false,
}) => {
  if (isEpicDone && openCount > 0) {
    return (
      <div className="mb-4 flex flex-wrap items-center gap-3 rounded-xl border border-[#FBBF2455] bg-[#FBBF2412] px-5 py-3.5">
        <AlertTriangle size={20} className="shrink-0 text-[#FBBF24]" />
        <p className="min-w-0 flex-1 text-sm text-[#FDE68A]">
          This Epic is Done, but {openCount} child work {openCount === 1 ? 'item is' : 'items are'} still open.
        </p>
        <button
          type="button"
          onClick={onReopen}
          disabled={isSaving}
          className="shrink-0 rounded-lg border border-primary-subtle bg-primary-variant px-4 py-2 text-sm font-medium text-neutral transition-colors hover:bg-primary-subtle disabled:opacity-50"
        >
          Reopen Epic
        </button>
      </div>
    );
  }

  if (!isEpicDone && totalCount > 0 && openCount === 0) {
    return (
      <div className="mb-4 flex flex-wrap items-center gap-3 rounded-xl border border-[#10B98155] bg-[#10B98112] px-5 py-3.5">
        <CheckCircle2 size={20} className="shrink-0 text-[#34D399]" />
        <p className="min-w-0 flex-1 text-sm text-neutral">All child work items are done. Mark this Epic as Done?</p>
        <button
          type="button"
          onClick={onMarkDone}
          disabled={isSaving}
          className="shrink-0 rounded-lg bg-[#10B981] px-4 py-2 text-sm font-semibold text-[#052E1C] transition-colors hover:bg-[#34D399] disabled:opacity-50"
        >
          Mark as Done
        </button>
      </div>
    );
  }

  return null;
};

export default EpicStatusBanner;
